<template>
  <div class="relative w-full">
    <span v-if="label" class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500 z-1">{{ label }}</span>
    <Combobox
      :model-value="modelValue"
      @update:modelValue="onSelect"
    >
      <div class="relative">
        <div class="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left focus:outline-none sm:text-sm">
          <ComboboxInput
            class="w-full basicInput !pr-10"
            :display-value="option => option"
            :placeholder="placeholder"
            :required="required"
            @input="onInput"
            @change="onChange"
            @keydown="onKeydown"
          />
          <ComboboxButton class="absolute inset-y-0 right-0 flex items-center !m-1 !h-7 rounded-2xl">
            <i class="fas fa-chevron-down"></i>
          </ComboboxButton>
        </div>
        <TransitionRoot
          leave="transition ease-in duration-100"
          leave-from="opacity-100"
          leave-to="opacity-0"
          @after-leave="onChange"
        >
          <ComboboxOptions
            class="absolute z-2 max-h-60 w-full overflow-auto rounded-xl bg-white shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
          >
            <template v-if="filteredOptions.length > 0">
              <ComboboxOption
                v-for="option in filteredOptions"
                as="template"
                :key="option"
                :value="option"
                v-slot="{ selected, active }"
              >
                <li
                  class="relative cursor-default select-none p-2 pr-3 flex items-center justify-between"
                  :class="{
                    'bg-primary text-white': active,
                    'text-gray-900': !active,
                  }"
                >
                  <span
                    class="block truncate"
                    :class="{ 'font-medium': selected, 'font-normal': !selected }"
                  >
                    {{ option }}
                  </span>
                  <!-- Croix pour retirer le modèle -->
                  <span
                    v-if="isOptionTemplate && isOptionTemplate(option)"
                    class="ml-2 cursor-pointer"
                    @mousedown.prevent.stop="removeTemplate(option)"
                    title="Retirer ce modèle"
                  >
                    <i class="fas fa-times"></i>
                  </span>
                  <span
                    v-if="selected"
                    class="absolute inset-y-0 left-0 flex items-center pl-3"
                    :class="{ 'text-white': active, 'text-teal-600': !active }"
                  >
                  </span>
                </li>
              </ComboboxOption>
            </template>
          </ComboboxOptions>
        </TransitionRoot>
      </div>
    </Combobox>
  </div>
</template>

<script>
import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
  TransitionRoot,
} from '@headlessui/vue'

export default {
  name: 'ActionCombobox',
  components: {
    Combobox,
    ComboboxInput,
    ComboboxButton,
    ComboboxOptions,
    ComboboxOption,
    TransitionRoot,
  },
  props: {
    modelValue: { type: String, default: '' },
    options: { type: Array, required: true },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    isOptionTemplate: { type: Function, default: null }, // (option) => boolean
  },
  emits: [
    'update:modelValue',
    'select',         // option sélectionnée explicitement
    'input',          // à chaque saisie
    'remove-template' // (option) => void
  ],
  data() {
    return {
      query: '',
      optionSelected: false,
    };
  },
  computed: {
    filteredOptions() {
      if (!this.query) return this.options;
      return this.options.filter(option =>
        option.toLowerCase().replace(/\s+/g, '').includes(this.query.toLowerCase().replace(/\s+/g, ''))
      );
    },
  },
  methods: {
    onInput(e) {
      this.query = e.target.value;
      this.$emit('input', this.query);
    },
    onSelect(value) {
      this.optionSelected = true;
      this.$emit('update:modelValue', value);
      this.$emit('select', value);
    },
    onChange() {
      if (!this.optionSelected && this.query) {
        this.$emit('update:modelValue', this.query);
        this.$emit('select', this.query);
      }
      this.optionSelected = false;
    },
    onKeydown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        // Valide la query actuelle comme valeur
        this.$emit('update:modelValue', this.query);
        this.$emit('select', this.query);
        this.optionSelected = true;
      }
    },
    removeTemplate(option) {
      this.$emit('remove-template', option);
    }
  }
};
</script>